import React from 'react';

export default () => (
  <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.2222 0H1.77778C0.791111 0 0 0.8 0 1.77778V12.4444C0 13.4222 0.791111 14.2222 1.77778 14.2222H5.33333V12.4444H1.77778V3.55556H14.2222V12.4444H10.6667V14.2222H14.2222C15.2 14.2222 16 13.4222 16 12.4444V1.77778C16 0.8 15.2089 0 14.2222 0ZM8 5.33333L4.44444 8.88889H7.11111V14.2222H8.88889V8.88889H11.5556L8 5.33333Z" fill="currentColor" />
  </svg>
);
